import axios from 'axios'
import Vue from 'vue'
import router from '../router/index'
// axios.defaults.timeout = 5000;                        //响应时间
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
axios.interceptors.request.use(
  (config) => {
    // if (localStorage.getItem('jx-token')) {
    //   config.headers['Authorization'] = localStorage.getItem('jx-token')
    // }
    return config
  },
  (err) => {
    window.console.log('请求超时')
    return Promise.resolve(err)
  }
)
// 统一的错误参数处理
axios.interceptors.response.use(
  (data) => {
    // if(data.data.is_login==0){
    //   Vue.prototype.$message.error("账号已被禁用")
    //   localStorage.removeItem('jx-token')
    //   localStorage.removeItem('jx-userinfo')
    //   localStorage.removeItem('jx-router')
    //   router.push('/login')
    //   window.location.reload()
    // }
    return data
  },
  (error) => {
    window.console.log(error)
  }
)
export default axios
